module.exports = __webpack_public_path__ + "static/media/elements-overlay.c4604929.png";